import React, { useEffect } from 'react'
import Button from "../../../shared/components/atoms/button/button";
import GenericModal from '../../../shared/components/organisms/generic-modal/generic-modal';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import useMobile from '../../../shared/hooks/useMobile';
import { GatsbyImage } from 'gatsby-plugin-image'
import './successful-redemption-modal.scss'

const SuccessfulRedemptionModal = ({ contentInfo, buttonCopy, buttonEvent, closeModal }) => {

    const mobile = useMobile();

    useEffect(() => {
        document.documentElement.style.overflowY = 'hidden';
        document.body.scroll = "no";
        return () => {
            document.documentElement.style.overflowY = 'scroll';
            document.body.scroll = "yes";
        }
    }, [])

    const title = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-m-successful-redemption-modal__title" >{next}</p>
        }
    };

    return (
        <div className="f-m-successful-redemption-modal">
            <GenericModal closeModal={closeModal}>
                <div className="f-m-successful-redemption-modal__content">
                    <div className="f-m-successful-redemption-modal__text">
                        {contentInfo && <p className="f-m-successful-redemption-modal__thanks">{contentInfo.tituloGeneral}</p>}
                        {contentInfo && contentInfo.descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.descripcion.raw), title)}
                        <p className="f-m-successful-redemption-modal__extra">Recuerda que tus puntos ayudarán a mi alimentación y a la de todos mis amiguitos</p>
                        {!mobile &&
                            <Button
                                id="f-a-buttton__successful-redemption-modal"
                                className={"f-a-button__primary-purple f-a-button__big f-m-successful-redemption-modal__button"}
                                copy={buttonCopy}
                                onclick={buttonEvent}
                            />
                        }
                    </div>
                    <div className="f-m-successful-redemption-modal__image-container">
                        {contentInfo && contentInfo.imagen && contentInfo.imagen[0] &&
                            <GatsbyImage
                                image={contentInfo.imagen[0].gatsbyImageData}
                                alt={contentInfo.imagen[0].description}
                                className="f-m-successful-redemption-modal__image"
                            />
                        }
                    </div>
                    {mobile &&
                        <Button
                            id="f-a-buttton__successful-redemption-modal"
                            className={"f-a-button__primary-purple f-a-button__big f-m-successful-redemption-modal__button"}
                            copy={buttonCopy}
                            onclick={buttonEvent}
                        />
                    }
                </div>
            </GenericModal>
        </div>
    )
}

export default SuccessfulRedemptionModal
